import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect } from 'react';
import COOKIES from '~/constants/cookies';
import DeviceContext from '~/context/common/DeviceContext';
import { BrowserCookies } from '~/utilities';

export default function useSendNativeDeviceTypeToDD() {
  const { nativeDeviceType } = useContext(DeviceContext);

  useEffect(() => {
    datadogRum.setGlobalContextProperty('isWebview', nativeDeviceType.isNative);
    datadogRum.setGlobalContextProperty('webview', {
      version: BrowserCookies.get(COOKIES.nativeAppVersion),
      platform: nativeDeviceType.platform
    });
  }, [nativeDeviceType]);
}
